import { apiFetch } from "./client";

export const OFFICIAL_EXPORT_FILE_NAMES = [
  "manifest.json",
  "suppliers.csv",
  "supplier_variant_costs.csv",
  "product_variants.csv",
  "purchase_order_items.csv",
  "stock_transfer_items.csv",
  "stock_take_items.csv",
  "stock_adjustment_items.csv",
  "min_max_available.csv",
] as const;

export type OfficialExportFileName =
  (typeof OFFICIAL_EXPORT_FILE_NAMES)[number];

export interface OfficialExportFileSummary {
  file_name: OfficialExportFileName;
  row_count: number | null;
  sha256: string;
  handling:
    | "normalized_and_retained"
    | "partially_normalized_and_retained"
    | "retained";
}

export interface OfficialExportImportResult {
  package_import_id: string;
  dry_run: boolean;
  plan_token: string | null;
  file_count: number;
  total_rows: number;
  files: OfficialExportFileSummary[];
  normalized_counts: Record<string, number>;
  action_counts: Record<string, number>;
  unmatched_variant_count: number;
  unmatched_supplier_count: number;
  warnings: string[];
  archived_files: number;
  already_applied: boolean;
  package_sha256: string;
  generated_at: string;
  stocky_account_id: string;
}

export interface OfficialExportImportRequest {
  packageImportId: string;
  files: readonly File[];
  planToken?: string;
}

const OFFICIAL_EXPORT = "/api/migrate/csv/official-export-v1";

function requestForm(request: OfficialExportImportRequest): FormData {
  const form = new FormData();
  form.set("package_import_id", request.packageImportId);
  if (request.planToken !== undefined) {
    form.set("plan_token", request.planToken);
  }
  for (const file of request.files) {
    form.append("files", file, file.name);
  }
  return form;
}

export function dryRunOfficialExport(
  request: OfficialExportImportRequest,
): Promise<OfficialExportImportResult> {
  return apiFetch(`${OFFICIAL_EXPORT}/dry-run`, {
    method: "POST",
    formData: requestForm(request),
  });
}

export function applyOfficialExport(
  request: OfficialExportImportRequest,
): Promise<OfficialExportImportResult> {
  return apiFetch(`${OFFICIAL_EXPORT}/apply`, {
    method: "POST",
    formData: requestForm(request),
  });
}
